<script lang="ts" setup>
import { faCheck } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { type BrandFetchSearch } from "~/services/BrandFetchService";
const props = defineProps<{
    show: boolean;
    loading: boolean;
    items: BrandFetchSearch[];
    selected: {
        id: string;
        name: string;
        icon: string;
        website: string;
        provider: string;
    };
}>();

const emit = defineEmits<{
    (e: "select", v: BrandFetchSearch): void;
}>();
const componentRef = ref<HTMLElement | null>(null);
</script>

<template>
    <div
        ref="componentRef"
        class="absolute mt-2 z-10 show bg-white rounded-lg shadow-lg w-full"
        :class="show ? 'show' : 'hidden'"
    >
        <div class="p-2 text-sm text-gray-700 divide-y divide-gray-100">
            <div v-if="loading" class="p-2 animate-pulse flex space-x-4">
                <div class="bg-gray-300 h-12 w-12 rounded"></div>
                <div class="flex-1 space-y-4 py-1">
                    <div class="h-2 bg-gray-300 w-1/2 rounded"></div>
                    <div class="space-y-2">
                        <div class="grid grid-cols-3 gap-2">
                            <div
                                class="h-2 bg-gray-300 rounded col-span-1"
                            ></div>
                            <div
                                class="h-2 bg-gray-300 rounded col-span-2"
                            ></div>
                        </div>
                        <div class="h-2 bg-gray-300 rounded"></div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div v-if="items.length" class="flex flex-col gap-1">
                    <div
                        v-for="brand in items"
                        :key="brand.brandId || brand.id"
                        class="p-2 rounded hover:bg-gray-200 cursor-pointer"
                        :class="
                            selected?.id &&
                            (selected.id === brand.brandId ||
                                selected.id === brand.id)
                                ? 'bg-gray-200'
                                : ''
                        "
                        @click="$emit('select', brand)"
                    >
                        <div class="flex">
                            <div class="flex-1 flex">
                                <div class="mr-4 flex-shrink-0 mt-1">
                                    <img
                                        v-if="brand.icon || brand.logo_url"
                                        class="h-12 w-12 bg-white rounded"
                                        :src="brand?.icon ?? brand?.logo_url"
                                        @error="
                                            $event.target.src =
                                                '/assets/logo/svg/linkedin_empty_company_logo.svg'
                                        "
                                    />
                                    <img
                                        v-else
                                        class="h-12 w-12 bg-white"
                                        src="/assets/logo/svg/linkedin_empty_company_logo.svg"
                                    />
                                </div>
                                <div>
                                    <h4 class="font-medium font-display">
                                        {{ brand.name }}
                                    </h4>
                                    <div class="flex flex-col mt-1">
                                        <p class="text-gray-500">
                                            {{ brand.domain ?? brand.website }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="
                                    selected?.id &&
                                    (selected?.id === brand.brandId ||
                                        selected?.id === brand.id)
                                "
                                class="flex items-center text-center p-2"
                            >
                                <FontAwesomeIcon :icon="faCheck" size="lg" />
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    v-else
                    class="p-2 flex flex-col items-center text-center gap-2"
                >
                    <p class="font-medium">No result found</p>
                    <p class="text-gray-500 text-xs">
                        We can't find any company with that term,<br />
                        try searching something else or adjust the filter.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
